import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    '& .recordTableHeader': {
      padding: theme.spacing(1),
    },
    '&.incomplete': {
      '& .recordTableHeader': {
        backgroundColor: '#fff8e1',
      },
      '& .MuiChip-root': {
        backgroundColor: '#ffd54f',
        color: '#000',
        '&.MuiChip-clickable:hover': {
          backgroundColor: '#ffe082',
        },
      },
    },
    '&.complete': {
      '& .recordTableHeader': {
        backgroundColor: '#c8e6c9',
      },
      '& .MuiChip-root': {
        backgroundColor: '#81c784',
        color: '#000',
        '&.MuiChip-clickable:hover': {
          backgroundColor: '#a5d6a7',
        },
      },
    },
    '&.locked': {
      '& .recordTableHeader': {
        backgroundColor: '#cfd8dc',
      },
    },
    '&.ignore': {
      '& .MuiChip-root': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&.MuiChip-clickable:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
        '& .MuiSvgIcon-root': {
          color: theme.palette.primary.contrastText,
        },
      },
    },
  },
}));
